export type DeviceStatus = "Active" | "Inactive";

export interface ITelematicsDeviceV2 {
  id?: string;
  /** Optional — devices may live unattached. */
  machineId?: string | null;
  accountId?: string;
  /** Optional friendly name supplied by the owner. */
  name?: string | null;
  deviceUniqueId: string;
  status: DeviceStatus;
  provider: string;
  isActive?: boolean;
  auditMetadata?: {
    createdDateTime?: string;
    modifiedDateTime?: string;
  };
}

export class TelematicsDeviceV2 implements ITelematicsDeviceV2 {
  id?: string;
  machineId?: string | null;
  accountId?: string;
  name?: string | null;
  deviceUniqueId: string;
  status: DeviceStatus;
  provider: string;
  isActive?: boolean;
  auditMetadata?: {
    createdDateTime?: string;
    modifiedDateTime?: string;
  };

  constructor(fields?: Partial<ITelematicsDeviceV2>) {
    this.machineId = fields?.machineId ?? null;
    this.accountId = fields?.accountId;
    this.name = fields?.name ?? null;
    this.deviceUniqueId = fields?.deviceUniqueId || "";
    this.status = fields?.status || "Active";
    this.provider = fields?.provider || "GpsAndFleet";
    this.isActive = fields?.isActive !== undefined ? fields.isActive : true;
    if (fields?.id) this.id = fields.id;
    if (fields?.auditMetadata) this.auditMetadata = fields.auditMetadata;
  }
}

export interface GpsAndFleetLocationData {
  driver: string;
  device: string;
  deviceType: string;
  event_name: string;
  date: string;
  lat: string;
  lng: string;
  event: string;
  time: string;
  mileage: any;
  speed: string;
  battery: string;
  csq: string;
  satellite: string;
  mode: string;
}

export interface GpsAndFleetApiResponse {
  status: boolean;
  message: string;
  /** Provider that produced the location ("GpsAndFleet" or "Sarekon"). */
  provider?: string;
  /**
   * True when SareKon successfully resolved this device, so starter disable
   * is available. Always false for GpsAndFleet-only devices.
   */
  supportsStarterDisable?: boolean;
  data: GpsAndFleetLocationData[];
}

export interface SarekonDisableStarterResponse {
  status: boolean;
  message: string;
  deviceId?: string;
  commandQueueId?: string;
  provider?: string;
}
